import { IComboBoxOption } from "src/components/ComboBox/ComboBox.context";

export const DEV_PARTNERS: IComboBoxOption[] = [
  { value: "1", label: "PINTRO" },
  { value: "378", label: "SAWALA Technology" },
  { value: "423", label: "SSDC" },
  { value: "4", label: "Esensi Solusi Buana" },
  { value: "5", label: "Bahasa.ai" },
  { value: "63", label: "82Cart" },
  { value: "7", label: "SPROUT DIGITAL LABS" },
  { value: "351", label: "ICUBE by SIRCLO" },
  { value: "9", label: "AIMSIS" },
  { value: "384", label: "Mineral" },
  { value: "84", label: "Kemana" },
  { value: "276", label: "Arlogy" },
  { value: "137", label: "SIRCLO Store" },
  { value: "14", label: "Alamaya" },
  { value: "15", label: "Ameera" },
  { value: "16", label: "AW Bali Digital" },
  { value: "309", label: "Canvas Web Design" },
  { value: "173", label: "Digital Alfa" },
  { value: "19", label: "Dreite" },
  { value: "20", label: "Compro" },
  { value: "324", label: "Eannovate" },
  { value: "129", label: "Flitts" },
  { value: "23", label: "Flixs Web Studio" },
  { value: "24", label: "Folio" },
  { value: "25", label: "Global Xtreme" },
  { value: "26", label: "Inovasi Solusi Digital" },
  { value: "38", label: "Jejualan" },
  { value: "28", label: "Kreasi Kode" },
  { value: "29", label: "Media Karya Nusantara" },
  { value: "30", label: "Nukegraphic" },
  { value: "123", label: "Olsera" },
  { value: "402", label: "Pentacode Digital" },
  { value: "411", label: "Progreestech" },
  { value: "34", label: "Quinos" },
  { value: "172", label: "Radya Labs" },
  { value: "36", label: "SigmaSolusi" },
  { value: "37", label: "STAMPS" },
  { value: "315", label: "Storelogy" },
  { value: "39", label: "Suvarna Media Informatika" },
  { value: "40", label: "Tourangga" },
  { value: "41", label: "Validata" },
  { value: "42", label: "Weefer" },
  { value: "43", label: "Whalemade" },
  { value: "217", label: "Worktrees" },
  { value: "78", label: "WIT" },
  { value: "447", label: "WEbArq" },
  { value: "47", label: "ABACUS" },
  { value: "48", label: "Mostar Studio" },
  { value: "49", label: "Timedoor Indonesia" },
  { value: "50", label: "Balesin.id" },
  { value: "51", label: "Titik Terang" },
  { value: "178", label: "Stand Studio" },
  { value: "44", label: "aCommerce" },
  { value: "211", label: "Altech Omega" },
  { value: "264", label: "Amadeo" },
  { value: "267", label: "Andhika (Perorangan)" },
  { value: "270", label: "Andre Perorangan" },
  { value: "273", label: "Apps2u" },
  { value: "279", label: "Artsys" },
  { value: "282", label: "ASCLAR" },
  { value: "285", label: "awwwstudio" },
  { value: "288", label: "Baba Studio" },
  { value: "291", label: "Bank Pixel" },
  { value: "294", label: "Biiiz" },
  { value: "297", label: "Bion (Perorangan)" },
  { value: "300", label: "BitGroup" },
  { value: "189", label: "Bong Fernandes Budianto" },
  { value: "303", label: "Boomer" },
  { value: "131", label: "Buka Toko" },
  { value: "205", label: "Cakra Studio" },
  { value: "306", label: "Calium Analytics" },
  { value: "102", label: "Cubeout Interactive" },
  { value: "312", label: "Cyanlabs" },
  { value: "134", label: "Cyberhost" },
  { value: "321", label: "DewaWeb" },
  { value: "318", label: "DJaring / Elven Digital" },
  { value: "327", label: "Easy Store" },
  { value: "330", label: "FaberHost" },
  { value: "333", label: "Ferry (Perorangan)" },
  { value: "336", label: "Flash Mobile" },
  { value: "339", label: "Gamatechno" },
  { value: "342", label: "Goodcommerce" },
  { value: "345", label: "Hartama" },
  { value: "348", label: "IcreativeLabs" },
  { value: "354", label: "Indociti" },
  { value: "357", label: "Indowebdeveloper" },
  { value: "360", label: "Indowebxpress" },
  { value: "363", label: "In House" },
  { value: "366", label: "inmotion" },
  { value: "369", label: "Insystgo" },
  { value: "372", label: "Jubari Lau" },
  { value: "375", label: "Kommercio" },
  { value: "208", label: "Label Ideas" },
  { value: "190", label: "LocalBrand.Asia" },
  { value: "381", label: "Lokavor studio" },
  { value: "387", label: "mulai.com" },
  { value: "390", label: "Naya Project" },
  { value: "393", label: "Other" },
  { value: "396", label: "Outpost - Interactive" },
  { value: "399", label: "Pelican Solutions" },
  { value: "108", label: "Picodio" },
  { value: "81", label: "Pixaal - Unonim" },
  { value: "405", label: "Port Cities" },
  { value: "408", label: "Procommerce" },
  { value: "414", label: "PT. Enkripsi Lintasnusa Verizon" },
  { value: "417", label: "Rachmat (Perorangan)" },
  { value: "420", label: "Revodesain" },
  { value: "180", label: "rubyh" },
  { value: "429", label: "Sigit Prasetyo" },
  { value: "432", label: "suitmedia" },
  { value: "60", label: "Synergy One (Sunnyday Inc)" },
  { value: "480", label: "Teknomas Cipta Global" },
  { value: "477", label: "Telogic" },
  { value: "474", label: "The-netwerk.id" },
  { value: "471", label: "Tim-Geek" },
  { value: "468", label: "Trimitrasis" },
  { value: "465", label: "twiscode" },
  { value: "462", label: "Vienci Studio" },
  { value: "459", label: "Visigraphic" },
  { value: "456", label: "Vision" },
  { value: "453", label: "v-Kios" },
  { value: "450", label: "Waruga" },
  { value: "444", label: "Webstoreku/tokofbku" },
  { value: "441", label: "Weekendinc" },
  { value: "177", label: "WGS" },
  { value: "438", label: "Whello" },
  { value: "435", label: "wise design lab" },
  { value: "93", label: "YDigital Asia" },
  { value: "426", label: "Zen Digital Solution" },
];
